import { ReactNode } from 'react'
import { cn } from 'src/utils/style'

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  className?: string
}

export const Container = ({ children, className, ...rest }: ContainerProps) => {
  return (
    <div
      className={cn('container rounded-lg border border-border bg-surface p-4', className)}
      {...rest}
    >
      {children}
    </div>
  )
}
